<template>
    <div id='mypid'>
        <div class="mypid">
            <div class="authorization_timeBox" v-if="user_info.taobao_token && user_info.lest_day>0">授权账号：{{user_info.taobao_name}}，距离授权到期剩余<span class="col_red">{{user_info.lest_day}}</span>天。<a :href='"https://oauth.taobao.com/authorize?response_type=code&client_id=24355733&redirect_uri=http%3A%2F%2Fxingluo.koxo.cn%2ftoken.php&state=" + user_info.urid' class="agin" >重新授权</a></div>
            <div class="authorization_shixiao" v-if="user_info.taobao_token && user_info.lest_day <=0">您绑定的授权账号 {{user_info.taobao_name}} <span class="col_red">授权已失效</span><a :href='"https://oauth.taobao.com/authorize?response_type=code&client_id=24355733&redirect_uri=http%3A%2F%2Fxingluo.koxo.cn%2ftoken.php&state=" + user_info.urid' class="agin">更新授权</a></div>
            <!-- <h3>PID设置</h3> -->
            <p class="explain">说明：</p>
            <p>• 阿里系统限制每次授权有效期30天，授权快到期前及时重新授权，否则功能失效。</p>
            <p>• 同一淘宝号若授权其他软件可能导致功能失效。</p>
            <p>• PID请务必与您高佣授权时的淘宝帐号相对应。</p>
            <p>• 使用不同的推广方式建议使用不同的PID。</p>
             <el-table v-if="user_info.taobao_token"
                :data="tableData"
                border
                style="width: 700px;">
                <el-table-column
                prop="pidPurpose"
                label="PID用途"
                width="130">
                </el-table-column>
                <el-table-column
                prop="pid"
                label="PID"
                width="280">
                </el-table-column>
                <el-table-column
                prop="stasustxt"
                label="配置状态"
                width="150">
                <template slot-scope="scope">
                    <span v-if='scope.row.stasustxt == 0' >未使用</span>
                    <span v-if="scope.row.stasustxt == 1 && user_info.lest_day > 0">正常 <i class="el-icon-success" style="color: #0cd60c"></i></span>
                    <span style="color: red" v-if="(scope.row.stasustxt == 2 || user_info.lest_day <= 0) && scope.row.stasustxt != 0">授权账号不匹配 <i class="el-icon-warning" style="color: red"></i></span>
                </template>
                </el-table-column>
                <el-table-column
                label="操作"
                width="140">
                <template slot-scope="scope">
                    <el-button @click="addPidHandle(scope.row)" type="text" size="small" class='addbtn' v-if="scope.row.stasustxt == 0">添加PID</el-button>
                    <el-button @click="updatePid(scope.row)" type="text" size="small" class='addbtn' v-if="scope.row.stasustxt != 0">更换PID</el-button>
                    <el-button type="text" size="small" class='addbtn' v-if="(scope.row.stasustxt ==2 || user_info.lest_day <= 0) && scope.row.stasustxt !=0" @click="againRetest">重新检查</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="noAuthorization" v-if="!user_info.taobao_token">暂无授权信息，请先点击 <el-button class='col_fff' type="primary" @click="centerDialogVisible = true">此处</el-button> 前往淘宝授权</div>
        </div>
         <!-- 淘宝授权弹框提示 -->
        <el-dialog
            title="授权提示"
            :visible.sync="centerDialogVisible"
            width="30%">
            <div class="tip_content">
                <div>此功能需要您的淘宝账号授权才可以完成</div>
                <div>请绑定授权后进行下一步操作</div>
                <div>
                    <img src="../../assets/my/taobao.png" class="taobao_icon">
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goAuthorization">使用淘宝账号授权</el-button>
            </span>
        </el-dialog>
        <!-- 添加pid对话框 -->
        <el-dialog
            :title="pidtitle"
            :visible.sync="addpid"
            width="25%"
            center>
            <div class="inputbox">PID<el-input v-model="pidvalue" placeholder="请输入内容" class="input"></el-input></div>
            <div class="tiptxt_add">PID必须是授权账号<span class="Auth_name">{{user_info.taobao_name}}</span>下的PID</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="pidSave" class="sureBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
      return{
        user_info:'',
        centerDialogVisible: false,
        addpid:false,
        pidvalue: '',
        pidtitle: '',
        pidPurposetxt:'',
        tableData: [{
          pidPurpose: 'QQ二合一',
          pid: '',
          stasustxt: '',          
        }, {
          pidPurpose: '微信淘口令',
          pid: '',
          stasustxt: ''
        }]
      }
    },
    name: 'mypid',
    components: {
    },
    created(){
      this.getUserInfo();
    },
    methods:{
        // 获取用户信息
        getUserInfo(){
           this.$http({
                method: 'GET',
                url: 'home/getUserInfo',
            }).then((res) => {
              if(res.code == 1){
                this.user_info = res.data;
                this.tableData[0].pid = res.data.qq_pid;       
                this.tableData[1].pid = res.data.wechat_pid;       
                this.tableData[0].stasustxt = res.data.qq_pid_status;       
                this.tableData[1].stasustxt = res.data.wechat_pid_status;       
              }
            }).catch((err) => {
                console.log(err);
            }) 
        },
    //   去授权
        goAuthorization(){
          this.centerDialogVisible = false; 
          window.open('https://oauth.taobao.com/authorize?response_type=code&client_id=24355733&redirect_uri=http%3A%2F%2Fxingluo.koxo.cn%2ftoken.php&state='+this.user_info.urid,'_self')
        },
        // 打开添加pid
        addPidHandle(e) {
           this.pidvalue = '';
           this.addpid = true;
           this.pidtitle = '添加PID'; 
           this.pidPurposetxt = e.pidPurpose;  
        },
        // 打开更换pid
        updatePid(e) {
           if(this.user_info.lest_day <= 0 ){
               this.centerDialogVisible = true;
               return;
           }
           this.pidvalue = '';
           this.addpid = true;
           this.pidtitle = '更换PID';
           this.pidPurposetxt = e.pidPurpose;  
        },
        // 保存pid
        pidSave(){
           let url = ''
           if(this.pidPurposetxt == 'QQ二合一') {
               url = 'home/addqqpid';
           }else if(this.pidPurposetxt == '微信淘口令') {
                url = 'home/addwechatpid';
           }
           if(!this.pidvalue) {
               this.$message('请输入PID');
               return;
           }
           this.$http({
                method: 'POST',
                url: url,
                params:{pid:this.pidvalue},
            }).then((res) => {
              if(res.code == 1){
                 this.addpid = false;
                 this.getUserInfo();
                 this.pidvalue = '';
              }else if(res.code == 0){
                 this.$message.error(res.data); 
              }
            }).catch((err) => {
                console.log(err);
            }) 
        },
        // 重新检测pid
        againRetest(){
            if(this.user_info.lest_day <= 0 ){
               this.centerDialogVisible = true;
               return;
            }
            this.getUserInfo();          
        },
    }
}
</script>

<style scoped>
.mypid{
   padding-left: 10px;
   padding-right: 30px;
    font-size: 12px;

}
.noAuthorization {
    font-size: 14px;
    height: 50px;
    line-height: 50px;
    background-color: #f5f7fa;
    padding-left: 15px;
}
.col_blue {
    color: #EA4C51;
}
.tip_content {
    text-align: center;
}
.authorization_timeBox {
    height: 40px;
    line-height: 40px;
    background-color: #f5f7fa;
    padding-left: 15px;
    margin-top: 15px;
}
.authorization_shixiao {
    height: 40px;
    line-height: 40px;
    background-color: rgba(255, 130, 100, 0.1);
    padding-left: 15px;
    margin-top: 15px;
}
.inputbox {
    white-space: nowrap;
}
.input {
    margin-left: 20px;
    width: 85%;
}
.tiptxt_add {
    margin-top: 6px;
    padding-left: 43px;
    color: #999;
    font-size: 12px;
}
.sureBtn {
    width: 150px;
}
.addbtn {
    color: #5188A6;
}
.agin{
    display: inline-block;
    width: 70px;
    height: 30px;
    background-color: #6435E8;
    text-align: center;
    line-height: 30px;
    border-radius: 4px;
    color: #fff;
    margin-left: 30px;
}
.col_red {
    color: red;
}
.col_fff{
    color:#fff;
}
.Auth_name {
    color: #EA4C51;
}
.taobao_icon {
    width: 60px;
    height: 60px;
    margin-top: 15px;
}
.el-dialog {
   border: 2px solid #333; 
}
.explain {
   font-size: 14px;
   font-weight: 700;
   margin-top:20px;
}
</style>
